<template>
    <div>
        <entry-write-component :entry-type="'entry'" :competitionKey="competitionKey"></entry-write-component>
<!--        <terms-modal></terms-modal>-->
    </div>
</template>

<script>
import EntryWriteComponent from "@/components/entry/EntryWriteComponent";
import TermsModal from "../../components/modal/TermsModal";

export default {
    name: "EnterWrite",
    mixins: [],
    components: {
        TermsModal,
        EntryWriteComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            competitionKey:this.$route.params.cid
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
